<footer class="bg-white px-4 shadow-md">
  <div class="flex flex-col text-xs items-start py-3">
    <span> {{ config?.instituicao }}</span>
    <span> versão: {{ version }}</span>
    <span>© 2012 - {{ currentYear }}</span>
  </div>
</footer>